import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieNotice: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already acknowledged the notice
        const hasAcknowledged = localStorage.getItem('cookie-notice-acknowledged');
        if (!hasAcknowledged) {
            setIsVisible(true);
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        // Store acknowledgment in localStorage
        localStorage.setItem('cookie-notice-acknowledged', 'true');
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                    className="fixed right-4 bottom-4 z-50 p-6 w-full max-w-md rounded-lg border shadow-xl backdrop-blur-sm bg-dark-800/95 border-dark-700/50"
                    role="alert"
                    aria-labelledby="cookie-notice-title"
                >
                    <div className="flex flex-col gap-4 justify-between items-start sm:flex-row sm:items-center">
                        <div className="flex-1">
                            <h2 id="cookie-notice-title" className="mb-2 font-semibold text-white">Cookie Policy</h2>
                            <p className="text-dark-300">
                                This website does not use cookies or collect any personal information. We respect your privacy.
                            </p>
                        </div>
                        <button
                            onClick={handleClose}
                            className="inline-flex justify-center items-center p-2 rounded-lg transition-colors bg-dark-700/50 hover:bg-dark-600 text-dark-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 focus:ring-offset-dark-900"
                            aria-label="Close cookie notice"
                        >
                            <X size={20} aria-hidden="true" />
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieNotice;